var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.emList),function(em){return _c('span',{key:em},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.select(em)}}},[_vm._v(_vm._s(em))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }